import { environmentNames } from "./environmentNames";

export const environmentsMap = Object.freeze({
  ["matsonline-cdt.maersk.com"]: environmentNames.TEST,
  ["matsonline-stage.maersk.com"]: environmentNames.PREPROD,
  ["matsonline.maersk.com"]: environmentNames.PROD,
});
